import { Fab, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SaveIcon from '@material-ui/icons/Save';
import SaveSingleToLib from '../../../../MyComponents/icons/SaveSingleToLib';
import SaveAllToLib from '../../../../MyComponents/icons/SaveAllToLib';
import DownloadImageIcon from '../../../../MyComponents/icons/DownloadImageIcon';
import PdfBoardIcon from '../../../../MyComponents/icons/PdfBoardIcon';
import SectionChapter from '../../SectionChapter';

const SaveMenuManagement = ({ language, classes, refs }) => {
    let saveMenu = [
        {
            id: 'tutorial.manageLesson.saveMenu.explanation',
            children: (
                <Fab
                    size='small'
                    style={{ background: 'rgba(255,205,52,0.3)' }}
                    className={classes.sampleFab}
                >
                    <SaveIcon />
                </Fab>
            ),
        },
        {
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.saveSingleBoard'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <SaveSingleToLib className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.saveSingleBoard.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.saveAllBoards'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <SaveAllToLib className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.saveAllBoards.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.downloadImage'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <DownloadImageIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.downloadImage.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.downloadPDF'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <PdfBoardIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.saveMenu.downloadPDF.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/SaveMenu.jpg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLesson-saveMenu'}
            title={'tutorial.manageLesson.saveMenu.title'}
            explanations={saveMenu}
            imageTop={false}
        />
    );
};

export default SaveMenuManagement;
